/**
 * Provides a generic setter function for updating the value of Vue refs in a state object.
 *
 * @param {Object.<string, import('vue').Ref>} stateRefs -
 *   An object mapping state variable names to Vue ref objects.
 *
 * @returns {Object}
 *   Returns an object containing the `setAtomic` function.
 *
 * @example
 * // In your Pinia store:
 * const foo = ref(false);
 * const bar = ref(0);
 * const { setAtomic } = useAtomicSetter({ foo, bar });
 * setAtomic('foo', true); // foo.value is now true
 */

export function useAtomicSetter(stateRefs) {
  const setAtomic = (stateVarName, value) => {
    if (stateRefs[stateVarName]) {
      stateRefs[stateVarName].value = value;
    } else {
      console.warn(`State variable ${stateVarName} does not exist.`);
    }
  };
  return { setAtomic };
}
